import InfoCard from "../../../../src/components/info-card.js";
import React, { Children } from "react";
import BookReview from "../../../../src/components/book-review.js";
export default {
  InfoCard,
  React,
  Children,
  BookReview
};